/**
 * Sort an array of items by their `order` property in ascending order.
 */
export const sortByOrder = <T extends { order: number }>(items: T[]): T[] => {
  return [...items].sort((a, b) => a.order - b.order)
}
